<template>
  <div class="wrapp">
    <div class="row">
      <div class="col-12">
        <h2>Meu Estoque</h2>
        <b-alert show variant="info" class="explain">
          Se você deseja disponibilizar um veículo para
          comercialização com a Rede, clique em ação. <br>
          Se você deseja excluir um veículo publicado, clique em ação.
        </b-alert>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="row col-12">
        <form @submit="false" class="col-4 form-inline">
            <b-form-input
            v-model="filter"
            @keyup="search"
            placeholder="Buscar ...">
            </b-form-input>
            <button class="btn btn-primary mb-2" @click="resetSearch">Limpar</button>
        </form>
        <div class="col-5 form-inline wid100">
            <div class="form-inline wid100" :class="userType">
              <stockFilters/>
            </div>
        </div>
        <div class="col-3">
            <form @submit="false" class="f-right text-right pt20">
              <div class="text-right f-right">
                <input
                  @click="changePublished"
                  type="checkbox"
                  class="custom-control-input"
                  id="select-published"
                  name="select-published"
                />
                <label
                  class="custom-control-label check-rounded"
                  for="select-published"
                >Filtrar somente publicados</label>
              </div>
            </form>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        variant="primary"
        type="grow"
        label="Spinning"
      ></b-spinner>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-12 mt-3 tbscroll">
          <b-table :items="items" :fields="fields" id="myStockTable">
            <template v-slot:cell(dtfat)="row">
                {{ convertDate(row.item.dtfat) }}
            </template>
            <template v-slot:cell(dataestq)="row">
                {{ convertDate(row.item.dataestq) }}
            </template>
            <template v-slot:cell(diasestq)="row">
                {{ calculateDays(row.item.dtfat, row.item.dataestq) }}
            </template>
            <template v-slot:cell(acao)="row">
              <div class="text-center">
                <div v-if="checkStatus(row.item.status) == 'publicado' "
                  :id="`publish-${row.item.idestoque_rede}`"
                  class="fa fa-minus publishButton"
                  @click="publishStock(row.item, false)"
                >
                </div>
                <div v-else
                  class="fa fa-plus publishButton"
                  @click="$bvModal.show(`input-data${row.item.idestoque_rede}`)"
                >
                </div>
                <b-modal
                  size="lg"
                  :id="`input-data${row.item.idestoque_rede}`"
                  title="Informações para contato"
                  @ok="publishStock(row.item, true)">
                  <b-alert show variant="info">
                    Informe os dados do responsável para
                    que outro concessionário entre em contato caso necessário.
                  </b-alert>
                  <div class="row">
                    <div class="col-6">
                      <label for="input-name">Nome</label>
                      <input
                        id="input-name"
                        v-model="nome"
                        type="text"
                        required
                        class="form-control"
                      >
                    </div>
                    <div class="col-6">
                      <label for="input-phone">Telefone</label>
                      <input
                        id="input-phone"
                        v-model="telefone"
                        type="text"
                        required
                        class="form-control"
                      >
                    </div>
                  </div>
                </b-modal>
              </div>
            </template>
            <template v-slot:cell(status)="row">
            {{ checkStatus(row.item.status) }}
            </template>
          </b-table>
        </div>
        <div class="pagination-users mb-5">
            <paginate
              v-model="page"
              :page-count="Math.ceil(this.total / this.limit)"
              :click-handler="changePage"
              :prevText="'‹'"
              :nextText="'›'"
              :activeClass="'active'"
              :containerClass="'pagination b-pagination'"
              :pageClass="'page-item'"
            >
            </paginate>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import stockFilters from '../../../organisms/stock-filter/index.vue';
import EventBus from '../../../../eventBus';
const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  name: 'MyStock',
  components: {
    stockFilters,
  },
  data: () => ({
    filter: null,
    userType: null,
    nome: null,
    telefone: null,
    typingTimer: null,
    doneTypingInterval: 500,
    userAuth: null,
    items: [],
    selectedAop: 'Todas',
    selectedRegion: 'Todas',
    page: 1,
    limit: 10,
    ctcli: [],
    loading: true,
    fields: [
      { key: 'ctcli', label: 'Conta' },
      { key: 'dealer', label: 'Concessionário' },
      { key: 'dtfat', label: 'Dt.Faturamento' },
      { key: 'dataestq', label: 'Dt.Estoque' },
      { key: 'diasestq', label: 'Dias', class: 'text-right' },
      { key: 'vin', label: 'Vin' },
      { key: 'baumuster', label: 'Baumuster' },
      { key: 'modelo', label: 'Modelo' },
      { key: 'up', label: 'Up' },
      { key: 'classe', label: 'Subsegmento' },
      { key: 'anomodelo', label: 'Ano Modelo' },
      { key: 'anofabricacao', label: 'Ano Fabricação' },
      // { key: 'codigo_cor', label: 'Codigo Cor' },
      { key: 'cor', label: 'Cor' },
      { key: 'acao', label: 'Ação' },
      { key: 'status', label: 'Status' },
    ],
  }),
  watch: {
    userType: function watchUserType() {
    },
  },
  computed: {
    ...mapState('myStock', ['list', 'total']),
    ...mapState('users', ['user']),
  },
  methods: {
    ...mapActions('users', ['getUser']),
    ...mapActions('myStock', ['getMyStock', 'addPublish', 'removePublish']),
  
    async loadData() {
      this.loading = true;
      await this.getMyStock({
        page: this.page,
        limit: this.limit,
        filter: this.filter,
        aop: this.selectedAop,
        regiao_mb: this.selectedRegion,
        published: this.published,
        ctcli: this.ctcli,
        segmentos: this.userAuth.segmentos,
      });
      this.items = this.list;
      this.loading = false;
    },
    changePage() {
      this.loadData();
    },
    checkStatus(status) {
      let stRet;
      if (status.length > 0) {
        stRet = status[0].status;
      } else {
        stRet = 'Não publicado';
      }
      return stRet;
    },
    async changePublished() {
      this.published = !this.published;
      await this.loadData();
    },
    async publishStock(item, status) {
      if(status) {
        await this.addPublish({
          token: this.userAuth.token,
          stockId: item.idestoque_rede,
          nome: this.nome,
          telefone: this.telefone,
          account: item.ctcli,
        })
      } else {
        await this.removePublish({
          token: this.userAuth.token,
          stockId: item.idestoque_rede,
        })
      }
        await this.loadData();
    },
    search() {
      this.items = [];
      if (
        this.filter !== ''
        && this.filter !== null
        && this.filter.length > 2
      ) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(
          this.loadData,
          this.doneTypingInterval,
        );
      } else {
        this.items = [];
        this.loadData();
      }
    },
    resetSearch() {
      this.filter = null;
      this.loadData();
    },
    convertDate(date) {
      return (`${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}`);
    },
    calculateDays(dtFat, dtEst) {
      const DAY = 24 * 60 * 60 * 1000;
      const dateFat = new Date(dtFat);
      const dateEst = new Date(dtEst);
      const mlsFat = dateFat.getTime();
      const mlsEst = dateEst.getTime();
      const dif = mlsEst - mlsFat;
      const qtdDays = dif / DAY;
      return (qtdDays);
    },
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },
  async mounted() {
    await this.getUser({ id: this.userAuth.id, token: this.userAuth.token });
    this.nome = this.user.name;
    this.telefone = this.user.celphone;
    this.userType = this.user.type;
    for (const obj of this.user.dealers) {
      this.ctcli.push(obj.account);
    }
    await this.loadData();
    EventBus.$on('change-aop', (newValue) => {
      this.selectedAop = newValue;
      this.loadData();
    });
    EventBus.$on('change-region', (newValue) => {
      this.selectedRegion = newValue;
      this.loadData();
    });

  },
};
</script>

<style lang="scss" scoped>
.wrapp {
  padding: 16px;
  max-height: calc(100vh - 72px);
  background-color: #f1f1f1;
  overflow: auto;
}
.fa-plus {
  color: green;
  cursor: pointer;
}
.fa-minus {
  color: red;
  cursor: pointer;
}
.f-right {
  float: right;
}
.explain {
  background-color: transparent;
  border: none;
  color: #212529;
}
.btn-primary {
  background-color: #694cfe !important;
  border-color: #694cfe !important;
  margin-left: 10px;
  margin-top: 5px;
}
.dealer {
  display: none;
}
</style>
<style>
th {
    background-color: #70ad47;
    color: #fff;
}
.pt20 {
  padding-top: 20px;
}
.check-rounded::before {
  border-radius: 50%;
}
.wid100 {
  width: 100%;
}
.tbscroll {
  overflow: auto;
}
</style>
